import React, {Component} from 'react';

import "./Footer.css";

class Footer extends Component {
    render() {

        return (
            <div className="footer">
                <p>M&F Distribuciones SRL © Todos los derechos reservados.</p>
                <div>
                    <a target="_blank" href="http://www.exadec.com">Diseño y Desarrollo</a>
                </div>
            </div>
        );
    }
}


export default Footer;


// WEBPACK FOOTER //
// ./src/layout/Footer/Footer.js